import { RatingComponent } from '@msdyn365-commerce/components';
import {
    ICoreContext
} from '@msdyn365-commerce/core';
import {
    format
} from '@msdyn365-commerce-modules/utilities';
import React from 'react';
export function renderRating(
    context: ICoreContext,
    typeName: string,
    id: string,
    avgRating?: number,
    totalRatings?: number,
    ariaLabel?: string
): JSX.Element | null {
    if (avgRating && avgRating !== 0) {
        const numRatings = (totalRatings && totalRatings.toString()) || '0';
        const ratingAriaLabel = getRatingAriaLabel(avgRating, ariaLabel);

        return (
            <RatingComponent
                context={context}
                id={id}
                typeName={typeName}
                avgRating={avgRating}
                ratingCount={numRatings}
                readOnly
                ariaLabel={ratingAriaLabel}
                data={{}}
            />
        );
    } else {
        return null;
    }
}
function getRatingAriaLabel(rating?: number, ratingAriaLabel?: string): string {
    if (rating && ratingAriaLabel) {
        const roundedRating = rating.toFixed(2);
        return format(ratingAriaLabel || '', roundedRating, '5');
    }
    return '';
}